import React from 'react'

const Height = () => {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.66631 0L7.45602 2.21017L8.18937 2.94353L9.14779 1.98511V11.4649L8.18937 10.5064L7.45602 11.2398L9.66631 13.45L11.8766 11.2398L11.1432 10.5064L10.1848 11.4649V1.98511L11.1432 2.94355L11.8766 2.21017L9.66631 0ZM2.6824 0.00743204C2.00931 0.0948595 1.39898 0.884414 1.39898 1.90678C1.39898 2.47018 1.59403 2.96847 1.87991 3.31297L2.22097 3.72383L1.69621 3.82247C1.32461 3.89232 1.05215 4.08864 0.819254 4.40827C0.586354 4.72794 0.408302 5.17331 0.283513 5.68656C0.057584 6.61643 0.00789296 7.75178 0 8.7526H1.23487L1.57395 13.2993C2.43509 13.4937 3.35451 13.4868 4.18387 13.3L4.48386 8.7526H5.65962C5.65885 7.73953 5.64588 6.58852 5.44116 5.65159C5.32829 5.135 5.15718 4.69029 4.92149 4.37425C4.68571 4.05825 4.40067 3.86308 3.98347 3.79844L3.4479 3.71548L3.78597 3.29191C4.05949 2.9492 4.24491 2.45661 4.24491 1.90684C4.24491 0.816863 3.5635 0.010111 2.8219 0.010111L2.6824 0.00743204Z" fill="#F3F4F6"/>
</svg>

  )
}

export default Height
